import {
  Button,
  PhoneMockup,
  PhoneMockupBodyLayout,
  PhoneMockupLayout,
  TextLink,
  WidgetHeader,
  WidgetHeaderContent,
  WidgetStatus,
} from '@frontend/ui-library';
import { getIdFromUrl } from '@frontend/utils';
import { useEffect } from 'react';

import { SatisfactionRating } from '../../components';
import links from '../../constants/links';
import { useWidgetContext } from '../../context/WidgetContext';

import { PageFields_CancelledPage_Fragment as CancelledPageFields } from '../../graphql/generated';
import { useRegisterHotjarPage } from '../../hooks';
import { isOfframpBill } from '../../utils';

export interface PaymentExpiredProps {
  data: CancelledPageFields;
}

const PaymentExpired = (props: PaymentExpiredProps) => {
  const { configureHeader } = useWidgetContext();
  useRegisterHotjarPage('payment-expired');

  const { cancelledPageData } = props.data;

  useEffect(() => {
    configureHeader({
      id: getIdFromUrl(),
      merchantName: cancelledPageData?.merchantName || '',
    });
  }, []);

  const isOffRamp = isOfframpBill(cancelledPageData?.billType);

  return (
    <PhoneMockupLayout>
      <PhoneMockup
        header={
          <WidgetHeader color="error">
            <WidgetHeaderContent
              title={isOffRamp ? 'Off ramp expired' : 'Payment expired'}
            />
          </WidgetHeader>
        }
      >
        <PhoneMockupBodyLayout
          bodyCentered
          body={
            <>
              <WidgetStatus
                emoji="⏰"
                title={isOffRamp ? 'Off ramp expired' : 'Payment expired'}
                description={
                  <>
                    You will receive an email for the transactions <br /> that
                    meet{' '}
                    <TextLink
                      size="inherit"
                      href={links.support.REFUND_POLICY}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      our refund policy.
                    </TextLink>
                  </>
                }
                data-test-id="paymentExpired"
              />
              <SatisfactionRating
                mt="32"
                rating={cancelledPageData?.rating || undefined}
              />
            </>
          }
          footer={
            cancelledPageData?.cancelUrl && (
              <Button
                as="a"
                href={cancelledPageData.cancelUrl}
                mt="16"
                size="large"
                variant="secondary"
              >
                Go back to store
              </Button>
            )
          }
        />
      </PhoneMockup>
    </PhoneMockupLayout>
  );
};

export default PaymentExpired;
